import PropTypes from 'prop-types'
import { NotStartedIcon, EmptyState } from '@lmc/ui-kit'

export default function EMARInitialAssessmentEmptyState(props) {
  const { resident, preferredPeopleNominative } = props

  return (
    <EmptyState
      icon={<NotStartedIcon />}
      title={`Finalise ${
        resident?.preferredName || resident.name.first
      }'s Initial Assessment to use eMAR`}
      description={`When you finalise the Initial Assessment for this 
        ${(preferredPeopleNominative, 's')}, you’ll be able to set up
        their eMAR.`}
    />
  )
}

EMARInitialAssessmentEmptyState.propTypes = {
  preferredPeopleNominative: PropTypes.string.isRequired,
  resident: PropTypes.object.isRequired,
}
